import { RootState } from "../../app/store";
import { useAppSelector } from "../../app/hooks";

export const useEstablishmentId = (): number => {
    return useAppSelector((state: RootState) => state.root.establishmentId);
};
